import catalog from './missionCatalog.json';

export const missionCatalog = catalog;
export type CatalogMission = (typeof catalog)[number];
export const soldierMissionId = 'mission.soldaten-i-boegen';
export const townSquareMissionId = 'mission.raadhustorvet.fire-erhverv';
